import React, { useState, useEffect } from 'react'
// import 'SalaryRegister.css'
import Reusabletable from '../reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/register_template/Salary_registers.xlsx"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileformInputMatrix from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrix'
import ImportFileformInputMatrixclientData from '../../../reUsableTemplates/ImportFileform/ImportFileformInputMatrixclientData'
import mainicon from "../../../../assets/register_assets/inputMatix/Salary_register/mainicon.png"
import Act_of_commision_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Act_of_commision_icon.png"
import basic_icon from "../../../../assets/register_assets/inputMatix/Salary_register/basic_icon.png"
import branch_id_icon from "../../../../assets/register_assets/inputMatix/Salary_register/branch_id_icon.png"
import client_id_icon from "../../../../assets/register_assets/inputMatix/Salary_register/client_id_icon.png"
import conveyance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/conveyance_icon.png"
import da_icon from "../../../../assets/register_assets/inputMatix/Salary_register/da_icon.png"
import Damage_loss_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Damage_loss_icon.png"
import emp_code_icon from "../../../../assets/register_assets/inputMatix/Salary_register/emp_code_icon.png"
import emp_name_icon from "../../../../assets/register_assets/inputMatix/Salary_register/emp_name_icon.png"
import ESI_icon from "../../../../assets/register_assets/inputMatix/Salary_register/ESI_icon.png"
import Fine_Date_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Fine_Date_icon.png"
import Fine_released_date_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Fine_released_date_icon.png"
import Fines_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Fines_icon.png"
import Gross_salary_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Gross_salary_icon.png"
import hra_icon from "../../../../assets/register_assets/inputMatix/Salary_register/hra_icon.png"
import Insurance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Insurance_icon.png"
import lop_icon from "../../../../assets/register_assets/inputMatix/Salary_register/lop_icon.png"
import Lwf_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Lwf_icon.png"
import maternity_benefits_icon from "../../../../assets/register_assets/inputMatix/Salary_register/maternity_benefits_icon.png"
import Minimum_rates_of_wages_payable_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Minimum_rates_of_wages_payable_icon.png"
import Mode_of_pay_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Mode_of_pay_icon.png"
import Net_pay_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Net_pay_icon.png"
import nfh_icon from "../../../../assets/register_assets/inputMatix/Salary_register/nfh_icon.png"
import ot_icon from "../../../../assets/register_assets/inputMatix/Salary_register/ot_icon.png"
import other_components_icon from "../../../../assets/register_assets/inputMatix/Salary_register/other_components_icon.png"
import Others_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Others_icon.png"
import over_time_icon from "../../../../assets/register_assets/inputMatix/Salary_register/over_time_icon.png"
import paid_days_icon from "../../../../assets/register_assets/inputMatix/Salary_register/paid_days_icon.png"
import Pf_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Pf_icon.png"
import pt_icon from "../../../../assets/register_assets/inputMatix/Salary_register/pt_icon.png"
import Salary_Advance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Salary_Advance_icon.png"
import service_weightage_icon from "../../../../assets/register_assets/inputMatix/Salary_register/service_weightage_icon.png"
import Society_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Society_icon.png"
import special_allowance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/special_allowance_icon.png"
import statutory_bonus_icon from "../../../../assets/register_assets/inputMatix/Salary_register/statutory_bonus_icon.png"
import subsistence_allowance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/subsistence_allowance_icon.png"
import Tds_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Tds_icon.png"
import Total_deduction_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Total_deduction_icon.png"
import Total_production_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Total_production_icon.png"
import OT_date_icon from "../../../../assets/register_assets/inputMatix/Salary_register/OT_date_icon.png"
import Fine_cause_date_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Fine_cause_date_icon.png"
import medical_alloance_icon from "../../../../assets/register_assets/inputMatix/Salary_register/Insurance_icon.png"

import { getUserRole } from "./../../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action';
import { uploadSalaryRegisterFile, getSalaryRegister, updateSalaryRegisterById, deleteSalaryRegisterRegisterById, multiDeleteSalaryRegisterFile } from './../../../../services/register_redux/register_actions/Salary_register.action';

function SalaryRegister({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const dispatch = useDispatch();
    const { date } = useParams();
    const [createData, setCreateData] = useState(null);
    const [editData, setEditData] = useState(null);
    const [deleteData, setDeleteData] = useState(null);
    const header = [
        { key: 'emp_code', value: 'Employee Code', input: 'string', readOnly:true   ,icon: emp_code_icon},
        { key: 'emp_name', value: 'Employee Name', input: 'string', readOnly:true   ,icon: emp_name_icon},
        { key: 'unit_id', value: 'Branch ID', input: 'string',readOnly:true  ,icon: branch_id_icon},
        { key: 'client_id', value: 'Organization ID', input: 'string',readOnly:true  ,icon: client_id_icon},
        { key: 'paid_days', value: 'Paid Days', input: 'number' ,icon: paid_days_icon},
        { key: 'lop_days', value: 'LOP Days', input: 'number' ,icon: lop_icon},
        { key: 'basic', value: 'Basic', input: 'number' ,icon: basic_icon},
        { key: 'hra', value: 'HRA', input: 'number' ,icon: hra_icon},
        { key: 'special_allowance', value: 'Speacial Allowance', input: 'number' ,icon: special_allowance_icon},
        { key: 'DA', value: 'DA', input: 'number' ,icon: da_icon},
        { key: 'conveyance', value: 'Conveyance', input: 'number' ,icon: conveyance_icon},
        { key: 'medical_allowance', value: 'Medical Allowance', input: 'number' ,icon: medical_alloance_icon},
        { key: 'ot', value: 'OT', input: 'number' ,icon: ot_icon},
        { key: 'nfh', value: 'NFH', input: 'number' ,icon: nfh_icon},
        { key: 'maternityBenefit', value: 'Maternity Benefits', input: 'number' ,icon: maternity_benefits_icon},
        { key: 'comp_others', value: 'Other Components', input: 'number' ,icon: other_components_icon},
        { key: 'subsistanceAllowance', value: 'Subsistance Allowance', input: 'number' ,icon: subsistence_allowance_icon},
        { key: 'service_weightage', value: 'Service Weightage', input: 'string' ,icon: service_weightage_icon},
        { key: 'st_bonus', value: 'Statutory Bonus', input: 'number' ,icon: statutory_bonus_icon},
        { key: 'minimum_rates_of_wages_payable', value: 'Minimum Rates of Wages Payable', input: 'number' ,icon: Minimum_rates_of_wages_payable_icon},
        { key: 'total_production_in_case_of_piece_rate', value: 'Total Production (Piece Rate)', input: 'number' ,icon: Total_production_icon},
        { key: 'ot_date', value: 'OT Date', input: 'date' ,icon: OT_date_icon},
        { key: 'total_overtime_hours_worked', value: 'Total Overtime Hours Worked', input: 'number' ,icon: over_time_icon},
        { key: 'arrears_from_last_month', value: 'Arrears from last month', input: 'number' ,icon: OT_date_icon},
        { key: 'wages_due', value: 'Wages Due', input: 'number' ,icon: OT_date_icon},
        { key: 'gross_salary', value: 'Gross Salary', input: 'number' ,icon: Gross_salary_icon},
        { key: 'ESI', value: 'ESI', input: 'number' ,icon: ESI_icon},
        { key: 'PF', value: 'PF', input: 'number' ,icon: Pf_icon},
        { key: 'PT', value: 'PT', input: 'number' ,icon: pt_icon},
        { key: 'TDS', value: 'TDS', input: 'number' ,icon: Tds_icon},
        { key: 'LWF', value: 'LWF', input: 'number' ,icon: Lwf_icon},
        { key: 'society', value: 'Society', input: 'number' ,icon: Society_icon},
        { key: 'Insurance', value: 'Insurance', input: 'number' ,icon: Insurance_icon},
        { key: 'damages_loss', value: 'Damages Loss', input: 'number' ,icon: Damage_loss_icon},
        { key: 'salary_advance', value: 'Salary Advance', input: 'number' ,icon: Salary_Advance_icon},
        { key: 'fines', value: 'Fines', input: 'number' ,icon: Fines_icon},
        { key: 'Act_of_Commission', value: 'Act of Commission', input: 'text' ,icon: Act_of_commision_icon},
        { key: 'Cause_Against_Fine', value: 'Whether workmen showed cause against fine or not, and if so date on which cause was shown', input: 'text' ,icon: Fine_cause_date_icon},
        { key: 'Fine_Imposed_Date', value: 'Date on which Fine Imposed', input: 'date' ,icon: Fine_Date_icon},
        { key: 'Fine_Realized_Date', value: 'Date on which Fine Realised', input: 'date' ,icon: Fine_released_date_icon},
        { key: 'others', value: 'Others', input: 'number' ,icon: Others_icon},
        { key: 'total_deduction', value: 'Total Deduction', input: 'number' ,icon: Total_deduction_icon},
        { key: 'net_pay', value: 'Net Pay', input: 'number' ,icon: Net_pay_icon},
        { key: 'mode_of_pay', value: 'Mode Of Pay', input: 'string' ,icon: Mode_of_pay_icon},
    ];
    const [actionChecked, setActionChecked] = useState("");

    const fetchdata = async () => {
        if (!date) return;
        setLoading(true);
        try {
            const response = await dispatch(getSalaryRegister(date));
            const data = Array.isArray(response?.data) ? response.data : [];
            setGetData(data);
        } catch (err) {
            console.error("Failed to fetch salary register:", err);
            setGetData([]);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchdata();
    }, [dispatch, date]);

    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);
    //         try {
    //             const response = await dispatch(uploadSalaryRegisterFile(file));
    //             console.log("upload employee master response", response);
    //             if (response.success == true) {
    //                 showSnackbar(response.message.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {
    //                 showSnackbar(response.message, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };

        const downloadBase64Excel = (contentBase64, filename) => {
        try {
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'salary_register_failed_rows.xlsx';
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (file) {
            setLoading(true);
            try {
                const response = await dispatch(uploadSalaryRegisterFile(file));
                console.log("upload salary register response", response);                
                if (response.success == true) {
                    const msg = response.message;
                    showSnackbar(msg.message || 'Upload completed', 'success');
                    setLoading(false);
                    fetchdata();
                    setFile(null); 
                    setActionChecked("create");
                    if (msg.error_file && msg.error_file.content_base64) {
                        downloadBase64Excel(msg.error_file.content_base64, msg.error_file.filename);
                    }
                } else {
                    const err = response.message;
                    const displayError = Array.isArray(err) ? err.slice(0, 3).join('; ') + (err.length > 3 ? ` ... and ${err.length - 3} more` : '') : (err && err.error) || err || 'Upload failed';
                    showSnackbar(displayError, 'warning');
                    setLoading(false);
                }
            } catch (error) {
                showSnackbar('An error occurred', 'error');
                setLoading(false);
            }
        }
    };

    const submitdelete = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(multiDeleteSalaryRegisterFile(id));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            const response = await dispatch(updateSalaryRegisterById(editedValues.id, editedValues));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        try {
            const response = await dispatch(deleteSalaryRegisterRegisterById(id));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };
    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());    
            const rawPermissions = response?.data?.permissions;
    
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
    
            parsedPermissions.forEach((item) => {
                const { section, module, sub_module } = item;
    
                if (section === "InputMatrix" && module === "InputMatrix") {
                    const employeePermission = sub_module.find(sub => sub.name === 'Salary Register');
                    if (employeePermission?.action) {
                        setCreateData(employeePermission.action.create);
                        setEditData(employeePermission.action.edit);
                        setDeleteData(employeePermission.action.delete);
                    }
                }
            });
    
        } catch (err) {
            console.error("Failed to fetch permissions:", err);
        }
    };
    
    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            if(date === new Date(response.data[0].current_month).toISOString().split('T')[0]){
                getUserPermission();
            }
        } catch (err) {
            console.error("Failed to fetch clients:", err);
        }
    };
    useEffect(() => {
        fetchcurrmonth();
    }, [dispatch]);
    return (
        <div className='container-fluid'>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Salary Register'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                date={date}
            /> */}
            {createData ? 
            // <ImportFileform
            //     setFiledata={setFile}
            //     title={'Salary Register'}
            //     filestemp={files}
            //     handleFileUpload={handleFileUpload}

            // />
            <ImportFileformInputMatrix
                setFiledata={setFile}
                title={'Salary Register'}
                filestemp={files}
                handleFileUpload={handleFileUpload}
                date={date}
                File={file}
            />:<ImportFileformInputMatrixclientData
                date={date}
                
            />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Salary Register'}
            data={getData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {editData}
            getDeletePermission = {deleteData}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            mainIconColor={"#fec53d"}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
        </div>
    )
}

export default SalaryRegister
